module.exports = __webpack_public_path__ + "static/media/11.17156ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/verdindung/11.png
// module id = 127
// module chunks = 0